module.exports = __webpack_public_path__ + "img/default_user_image.7861dadc.png";